export default __webpack_public_path__ + "static/media/restaurant-leader-milestone-tracker-header.85f1f0e5.png";